import { MoovStep } from "./moovStep";
import { Parameter } from "./moovStepDefinition";
import { IServiceParameter, PremierServiceProduct } from "./premierServiceProduct";

export class Preset{
  public name!: string;
  public defaultValue!: string;
  public parameters!: AbstractParameter[];

  get inputType(){
    return this.parameters.length>0?this.parameters[0].inputType:'slt'; //should always be >0 otherwise preset would be worhtless
  }

  get options(){
    return this.parameters.length>0?this.parameters[0].options:[]; //should always be >0 otherwise preset would be worhtless
  }

  public containsParameter(ap:AbstractParameter):boolean{
    let result:boolean=false;
    for(var p of this.parameters){
      if(p.name==ap.name && p.moovStepDefinitionId==ap.moovStepDefinitionId && p.moovStepSequenceNo==ap.moovStepSequenceNo) {
        result=true;
        break;
      }
    }
    return result;
  }
}

export class AbstractParameters {
  public parameterArray:AbstractParameter[] = [];
  
  constructor(moovStep:MoovStep);
  constructor(moovStep:MoovStep, premierServiceProduct:PremierServiceProduct);
  
  constructor(moovStep:MoovStep, premierServiceProduct?:PremierServiceProduct){
    if(moovStep.parameterOptionId! > 0){
      let po = moovStep.moovStepDefinition?.parameterOptions?.find(po=>po.id==moovStep.parameterOptionId);
      if(po){
        po.parameters.filter(p=>p.canConfigurationOverride).forEach(p=>{
          let abstractParameter = new AbstractParameter(moovStep, p);
          this.parameterArray.push(abstractParameter);
        });
      }
    }
    if(premierServiceProduct){
      premierServiceProduct.parameterTemplate?.forEach(pt=>{
        let abstractParameter = new AbstractParameter(moovStep, undefined, pt, premierServiceProduct.id);
        this.parameterArray.push(abstractParameter);
      });
    }    
  }
}

export class AbstractParameter {
  
  public moovStepDefinitionId!: number;
  public moovStepSequenceNo!: number;
  public moovStepName!: string;
  public moovStepDescription!: string;
  public parameterSource!: string; //parameter can come from moovStepDefintion (msd) or from premierServiceProduct (psp)
  public premierServiceProductId!: number; //in case preset comes from a psp
  public label!: string;
  public name!: string;
  public inputType!: string;
  public options!: any[]; //if parameterSource is moovStepDefinition, this will be an array of name/value pairs; if parameterSource is premierServiceProduct, this will be an array of strings
  public disabled:boolean = false; //needed for the UI to disable the field if it is not selectable

  constructor(moovStep:MoovStep, moovStepParameter?:Parameter);
  constructor(moovStep:MoovStep, moovStepParameter?:Parameter, premierServiceParameter?:IServiceParameter, premierServiceProductId?:number);

  constructor(moovStep:MoovStep, moovStepParameter?:Parameter, premierServiceParameter?:IServiceParameter, premierServiceProductId?:number){
    //we can only process either or here. that means either moovStepParameter or premierServiceParameter should be provided.
    this.moovStepDefinitionId = moovStep.moovStepDefinitionId
    this.moovStepSequenceNo = moovStep.sequenceNo;
    this.moovStepName = moovStep.moovStepDefinition?.description || "";
    this.moovStepDescription = moovStep.moovStepDefinition?.description || "";

    if(premierServiceParameter){
      this.parameterSource = "psp";
      this.premierServiceProductId = premierServiceProductId!;
      this.label = premierServiceParameter.label;
      this.name = premierServiceParameter.name;
      this.inputType = premierServiceParameter.inputType;
      this.options = premierServiceParameter.options;
    }
    else if(moovStepParameter){
      this.parameterSource = "msd";
      this.label = moovStepParameter.label;
      this.name = moovStepParameter.name;
      this.inputType = moovStepParameter.inputType;
      this.options = moovStepParameter.inputOptionArray!;
    }
  }

  public static isCompatible(ap1:AbstractParameter, ap2:AbstractParameter):boolean{
    let compatible = (ap1.parameterSource === ap2.parameterSource && ap1.name === ap2.name && ap1.inputType === ap2.inputType);
    if (compatible){
      //now check if options are compatible
      if(ap1.options!=undefined || ap2.options!=undefined){
        if(ap1.parameterSource === "msd"){
          //both are msd because of first check => check for parameternames
          let ap1_options = ap1.options.map(o=>o.value as string);
          let ap2_options = ap2.options.map(o=>o.value as string);
          //check if each option1 occurs in options2
          for(const option1 of ap1_options) {
            if(!ap2_options.find(option2 => option1===option2)){
              compatible=false;
              break;
            }
          }
          //now check vice versa
          if(compatible){
            for(const option2 of ap2_options) {
              if(!ap1_options.find(option1 => option2===option1)){
                compatible=false;
                break;
              }
            }
          }
        }
      }
    }
    return compatible;
  }
}

export class PresetValues{
  public customerPremierPartnerServiceConfigurationId?:number;
  public values!: PresetValue[];
  constructor(){
    this.values=[];
  }
}
export class PresetValue{
  public name!:string;
  public value?:string;
}